import ImageKit from "imagekit-javascript"

export default (context, inject) => {
  const imagekit = new ImageKit({
    publicKey : "public_BjX116JRo6lN9UbgS6AQGOrjg+E=",
    urlEndpoint: "https://ik.imagekit.io/km2xccxuy",
    transformationPostion: 'src'
  })
  inject('imagekit', imagekit)
}